export default __webpack_public_path__ + "static/media/ohnp_66eb_230222.be3cd23d.jpg";